import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const gadgetApiService = {
    addManExcessCalc,
    setDisabled,
    getForClaim,
    getHistory
}

function addManExcessCalc(payload) {
    return axios.post(baseUrl + '/api/admin/v1/gadgetexcess/addmanualgadgetexcesscalc', payload)
}

function setDisabled(payload) {
    return axios.post(baseUrl + '/api/admin/v1/gadget/setdisabled', payload)
}

function getForClaim(payload) {
    return axios.get(baseUrl + '/api/admin/v1/gadget/forclaim/' + payload)
}

function getHistory(payload) {
    return axios.get(baseUrl + '/api/admin/v1/gadget/statushistory/' + payload)
}